import { app } from '../../../bootstrap/core';
import { breadcrumbComponent } from './breadcrumb.component';
import './templates/breadcrumb.default.tpl.html';
import './templates/breadcrumb.navigator.tpl.html';

app.component('breadcrumb', breadcrumbComponent);
